import { render } from "./ClinicAboutInfo.vue?vue&type=template&id=5af829a2&scoped=true&ts=true"
import script from "./ClinicAboutInfo.vue?vue&type=script&lang=ts"
export * from "./ClinicAboutInfo.vue?vue&type=script&lang=ts"

import "./ClinicAboutInfo.vue?vue&type=style&index=0&id=5af829a2&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af829a2"]])

export default __exports__